// extracted by mini-css-extract-plugin
module.exports = {"styles":"_2CP1Ysl6bky2-AyAn8tq_T"};